import React, { useContext, useEffect, useState } from 'react'
import './FilterPanel.css'
import { withStyles } from '@material-ui/core/styles'
import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import RadioBox, { GreenRadio } from '../../../../product/components/atoms/RadioBox'
import ProductContext from '../../../../product/context/product/productContext'
import CustomCommonContext from '../../../../custom/context/common/commonContext'
import ProductCommonContext from '../../../../product/context/common/commonContext'
import { useFormik } from 'formik'
import { Button } from '@material-ui/core'
import CheckBox from '../../../../product/components/atoms/CheckBox'

const Accordion = withStyles({
    root: {
        border: '1px solid rgba(0, 0, 0, .125)',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})(MuiAccordion)

const AccordionSummary = withStyles({
    root: {
        backgroundColor: '#fff',
        marginBottom: -1,
        minHeight: 56,
        '&$expanded': {
            minHeight: 50,
        },
    },
    content: {
        '&$expanded': {
            margin: '12px 0',
        },
    },
    expanded: {},
})(MuiAccordionSummary)

const AccordionDetails = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiAccordionDetails)

const FilterPanel = (props) => {
    const customCommonContext = useContext(CustomCommonContext)
    const productCommonContext = useContext(ProductCommonContext)

    const productContext = useContext(ProductContext)
    const { active_sorts, getAllActiveSorts } = productContext
    const { allCategory, allCondition, allLocations } = customCommonContext
    const { setSearchValue } = productCommonContext

    const [expanded, setExpanded] = React.useState('panel0')

    const sortValues = props.sorts
    const formik = useFormik({
        initialValues: {
            filters: {
                category: {
                    value: [],
                    type: 'array',
                    field: 'it.categoryTypeId',
                },
                searchbar: {
                    value: '',
                    type: 'like',
                    field: 'p.title,p.desc_proc',
                },
                condition: {
                    value: [],
                    type: 'array',
                    field: 'it.conditionTypeId',
                },
                subCategory: {
                    value: [],
                    type: 'array',
                    field: 'it.subCategoryTypeId',
                },
                location: {
                    value: [],
                    type: 'array',
                    field: 'p.location_id',
                },
                price: {
                    value: 0,
                    type: 'greaterequal',
                    field: 'p.wprice',
                },
                auctionid: {
                    value: [],
                    type: 'array',
                    field: 'p.auctionid',
                },
            },
        },
    })

    useEffect(() => {
        getAllActiveSorts({})
    }, [])

    useEffect(() => {
        if (props.search) {
            let searchValue = props.search.filters
            if (searchValue?.category?.value.length > 0) {
                formik.values.filters.category.value = searchValue.category.value.map((cat) => {
                    return cat.toString()
                })
            } else {
                formik.values.filters.category.value = []
            }
            if (searchValue?.condition?.value.length > 0) {
                formik.values.filters.condition.value = searchValue.condition.value.map((cat) => {
                    return cat.toString()
                })
            } else {
                formik.values.filters.condition.value = []
            }
            if (searchValue?.location?.value.length > 0) {
                formik.values.filters.location.value = searchValue.location.value.map((cat) => {
                    return cat.toString()
                })
            } else {
                formik.values.filters.location.value = []
            }
            if (searchValue?.price?.value) {
                formik.values.filters.price.value = searchValue.price.value
            } else {
                formik.values.filters.price.value = 0
            }
        }
    }, [props.search])

    useEffect(() => {
        if (props.from === 1) {
            const searchConst = props.search
            const formikValues = formik.values
            props.setSearch({ ...searchConst, ...formikValues })
        } else {
            if (
                formik.values.filters.category.value.length > 0 ||
                formik.values.filters.condition.value.length > 0 ||
                formik.values.filters.location.value.length > 0 ||
                formik.values.filters.price.value !== 0
            ) {
                setSearchValue(formik.values)
            }
        }
    }, [formik.values])

    let sortedCategories = []
    let sortedConditions = []
    let sortedCountries = []
    if (sortValues) {
        if (sortValues.categorysort) {
            sortedCategories = allCategory.filter((inner) =>
                sortValues.categorysort.includes(inner.id.toString()),
            )
        } else {
            sortedCategories = allCategory
        }
        if (sortValues.conditionsort) {
            sortedConditions = allCondition.filter((inner) =>
                sortValues.conditionsort.includes(inner.id.toString()),
            )
        } else {
            sortedConditions = allCondition
        }

        if (sortValues.locationsort) {
            sortedCountries = allLocations.filter((inner) =>
                sortValues.locationsort.includes(inner.id.toString()),
            )
        } else {
            sortedCountries = allLocations
        }
    } else {
        sortedCategories = allCategory
        sortedConditions = allCondition
        sortedCountries = allLocations
    }

    const filterValues = [
        {
            title: 'Category',
            type: 'check',
            name: 'category',
            item: allCategory.filter((main) => {
                if (
                    main.level === 0 &&
                    (active_sorts && active_sorts.sorts && active_sorts.sorts.sortcategoryTypes
                        ? active_sorts.sorts.sortcategoryTypes.includes(main.id.toString())
                        : true)
                ) {
                    return true
                }
            }),
        },
        {
            title: 'Sub category',
            type: 'check',
            name: 'subCategory',
            item: allCategory.filter((subcat) => {
                if (
                    subcat.level === 1 &&
                    (active_sorts && active_sorts.sorts && active_sorts.sorts.sortsubCategoryTypes
                        ? active_sorts.sorts.sortsubCategoryTypes.includes(subcat.id.toString())
                        : true) &&
                    formik &&
                    formik.values.filters &&
                    formik.values.filters.category.value &&
                    formik.values.filters.category.value.length
                        ? formik.values.filters.category.value.includes(subcat.level_id.toString())
                        : false
                ) {
                    return true
                }
            }),
        },
        {
            title: 'Location',
            type: 'check',
            name: 'location',
            item: allLocations.filter((main) => {
                if (
                    active_sorts && active_sorts.sorts && active_sorts.sorts.sortlocations
                        ? active_sorts.sorts.sortlocations.includes(main.id.toString())
                        : true
                ) {
                    return true
                }
            }),
        },
        {
            title: 'Price',
            type: 'radio',
            name: 'price',
            item: [
                { id: 0, description: 'All' },
                { id: 10, description: '10 AED & UP' },
                { id: 100, description: '100 AED & UP' },
                { id: 500, description: '500 AED & UP' },
                { id: 1000, description: '1000 AED & UP' },
                { id: 5000, description: '5000 AED & UP' },
            ],
        },
        {
            title: 'Conditions',
            type: 'check',
            name: 'condition',
            item: allCondition,
        },
    ]

    const handleChange = (panel) => (event, newExpanded) => {
        if (panel === expanded && !newExpanded) {
            setExpanded(newExpanded ? panel : false)
        } else {
            setExpanded(newExpanded ? panel : false)
        }
    }

    return (
        <div className="filterPanel">
            <div className="d-flex justify-content-between align-items-center filterTitleCnt">
                <h4 className="fpTitle">{'Filters'}</h4>
                {props.clearSearch && (
                    <Button onClick={() => props.clearSearch()} className="filterClear">
                        <span className="material-icons">cancel</span>
                        {'Clear all'}
                    </Button>
                )}
            </div>
            <div className="filterAcc">
                {filterValues.map((data, index) => (
                    <Accordion
                        square
                        key={index}
                        expanded={
                            expanded === `panel${index}`
                            // || formik.values[data.name].length > 0
                        }
                        onChange={handleChange(`panel${index}`)}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1d-content"
                            id={`panel${index}d-header`}
                        >
                            <h6 className="accTitle">{data.title}</h6>
                        </AccordionSummary>
                        <AccordionDetails>
                            {data.item && data.item.length > 0 ? (
                                <div className="filterCheck d-flex align-items-center flex-wrap">
                                    {data.type === 'check' ? (
                                        data.item.map((d, i) => (
                                            <>
                                                <CheckBox
                                                    name={`filters.${data.name}.value`}
                                                    label={
                                                        data.name === 'location'
                                                            ? `${d.name}`
                                                            : d.description
                                                    }
                                                    checked={
                                                        formik.values.filters[
                                                            data.name
                                                        ].value.indexOf(d.id.toString()) !== -1
                                                            ? true
                                                            : false
                                                    }
                                                    value={d.id.toString()}
                                                    onChange={formik.handleChange}
                                                />
                                            </>
                                        ))
                                    ) : (
                                        <>
                                            <RadioBox
                                                items={data.item}
                                                value={formik.values.filters[data.name].value}
                                                onChange={formik.handleChange}
                                                name={`filters.${data.name}.value`}
                                                int={1}
                                            />
                                        </>
                                    )}
                                </div>
                            ) : (
                                <small>{`No ${data.title} Found`}</small>
                            )}
                        </AccordionDetails>
                    </Accordion>
                ))}
            </div>
        </div>
    )
}
export default FilterPanel
